/* eslint-disable no-underscore-dangle */
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FieldsDataService {
  private _visibleFieldsCount: BehaviorSubject<string | number> =
    new BehaviorSubject('0');

  constructor() {}

  getVisibleFieldsCount(): Observable<string | number> {
    return this._visibleFieldsCount.asObservable();
  }

  setVisibleFieldsCount(count: number) {
    this._visibleFieldsCount.next(count.toString());
  }
}
